"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionMonitoringDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.TransactionMonitoringDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.transaction_monitoring_description.label',
    fallbackLabel: 'Please provide a high level description of the transaction monitoring process, please include as well information if the process is automated, manual (or a combination of both).',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_transaction_monitoring', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_transaction_monitoring === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_transaction_monitoring === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
